/**
 * Checks if passed value is not empty
 *
 * @param value - value which we want to check if it's not empty
 * @returns if value is not empty
 */
function isNotEmpty(value) {
  return value !== null && value !== undefined && !(Array.isArray(value) && value.length === 0) && value !== "";
}
export default isNotEmpty;